import { StateSchema } from 'app/providers/StoreProvider';

export const getSearchVersionPreference = (state: StateSchema) =>
    state.searchVersionPreference.preference;

export const getLastUsedSearchVersion = (state: StateSchema) =>
    state.searchVersionPreference.lastUsedVersion;
